/**
 * 个人中心菜单相关
 */
export const strict = false
import AccountRouter from '@/components/AccountMain/account-router.js'
export const state = () => ({
	centerMenu: [...AccountRouter] // 个人中心菜单
})
export const mutations = {
	SET_CENTER_MENU: (state, menu) => {
		state.centerMenu = menu
	}
}

export const actions = {
	/**
	 * 设置个人中心左侧菜单小红点
	 */
	onSetCenterDotMenu({ commit }, payload) {
		return new Promise(resolve => {
			const { menu, userAccount } = payload
			if (!userAccount) {
				commit('SET_CENTER_MENU', menu)
				resolve(menu)
				return
			}
            console.log(userAccount,'123');

			const { buyerTodoTotal, sellerTodoTotal, goodsTodoTotal, bargainBuyerTodoTotal, bargainSellerTodoTotal } = userAccount
			// 如果计数都是0则返回原数组
			if ([buyerTodoTotal, sellerTodoTotal, goodsTodoTotal, bargainBuyerTodoTotal, bargainSellerTodoTotal].every(value => value === 0)) {
				commit('SET_CENTER_MENU', menu)
				resolve(menu)
				return
			}

			const subMenuDotTotal = {
				myOrder: buyerTodoTotal, // 我的订单
				myGoods: parseInt(sellerTodoTotal) + parseInt(goodsTodoTotal), // 我的商品
				bargainBuyer: bargainBuyerTodoTotal, // 砍价 - 我是买家
				bargainSeller: bargainSellerTodoTotal // 砍价 - 我是卖家
			}

			function updateDotValues(items) {
				return items?.map(item => {
					// 创建一个新的对象，保持原始对象不变
					const updatedItem = { ...item }
					if (updatedItem.dotKey) {
						updatedItem.dot = subMenuDotTotal[updatedItem.dotKey]
					}
					if (updatedItem?.childrenDot) {
						// 递归更新子项
						updatedItem.children = updateDotValues(updatedItem.children)
					}
					return updatedItem
				})
			}
			const dotMenu = updateDotValues(menu)
			commit('SET_CENTER_MENU', dotMenu)
			resolve(dotMenu)
		})
	}
}
export const getters = {
	centerMenu: state => state.centerMenu
}
